import ComplianceAuditListing from './ComplianceAuditListing'
import './ComplianceAudit.sass'

export default ComplianceAuditListing
